import axios from "axios";

const updateUser = async (updateObject) => {
  try {
    const token = JSON.parse(localStorage?.getItem("user"))?.token;

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/update`,
      { updateObject },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
      isError: true,
      message: "error",
      user: null,
    };
  }
};

/**
 * in order to generate new otp
 * @param {Object} : {url: base url , number: phone number}
 * @returns {Promise} : returns a promise that will be resolved with an object or rejects with an error
 */
const generate_otp = async ({ inputNumber, type }) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/generateotp/${inputNumber}?type=${type}`
    );
    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
      isError: true,
      message: "wrong respose from the server",
      isExist: false,
      hash: null,
    };
  }
};

const get_user = async ({ url, number }) => {
  try {
    const res = await axios.get(`${url}/api/users/getUser/${number}`);
    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
      isError: true,
      message: "error",
      user: null,
    };
  }
};

/**
 * in user data on the basis of number
 * @param {Object} : {url: base url , number: phone number}
 * @returns {Promise} : returns a promise that will be resolved with an object {      isSuccess: boolean,
 *  isError: boolean,
 *  message: String,
 *  user: object} or rejects with an error
 */
const register_user = async ({ url, formdata }) => {
  try {
    const res = await axios.post(`${url}/api/users/register`, formdata);
    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
      isError: true,
      message: "error",
      user: null,
    };
  }
};

const grant_access_for_admin = async ({ url, accessToken }) => {
  try {
    const res = await axios.get(
      `${url}/api/users/grant_access_for_admin/${accessToken}`
    );
    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
    };
  }
};

const deleteUserPermanentlyApi = async ({ phoneNumber, otp, otpHash }) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/deleteUserPermanently`,
      { phoneNumber, otp, otpHash }
    );
    return res.data;
  } catch (error) {
    console.log(error);
    return {
      isSuccess: false,
    };
  }
};

export default function userApi() {
  return {
    updateUser,
    generate_otp,
    get_user,
    register_user,
    grant_access_for_admin,
    deleteUserPermanentlyApi,
  };
}

export {
  generate_otp,
  get_user,
  register_user,
  grant_access_for_admin,
  deleteUserPermanentlyApi,
};
